/**
 * L'INTERRUPTEUR du mode démo, lu par le client d'API à chaque appel.
 *
 * Il vit hors du store Pinia pour que `lib/api.ts` le consulte sans dépendre
 * de Pinia (ni créer d'import circulaire) : c'est le store `decouverte` qui le
 * pilote.
 */
let actif = false;

export function demoActive(): boolean {
  return actif;
}

export function basculerDemo(etat: boolean): void {
  actif = etat;
}
